export default "__VITE_ASSET__3970cd28__"